import { createSelector } from "@reduxjs/toolkit";
import { memoize } from "es-toolkit";

import type { DesignerNode } from "../../types/index.ts";
import { layoutIdByContentIdMapSelector, layoutTitleByIdMapSelector } from "./layoutIdMapSelectors.ts";

export const getLayoutCustomTitleForContentNodeSelector = createSelector(
  [layoutIdByContentIdMapSelector, layoutTitleByIdMapSelector],
  (layoutIdByContentIdMap, layoutTitleByIdMap): GetLayoutTitle =>
    memoize((node) => {
      const layoutId = layoutIdByContentIdMap.get(node.id);
      if (!layoutId) return;
      return layoutTitleByIdMap.get(layoutId);
    }),
);

export type GetLayoutTitle = (node: Pick<DesignerNode, "id">) => string | undefined;
